<p-button class="add"
          icon="pi pi-plus"
          severity="secondary"
          size="small"
          (click)="visible.set(true)"/>

<p-drawer [(visible)]="visible" header="Добавление элемента" position="right" styleClass="add-element-drawer">
    @for (element of elementTypes | keyvalue; track element.key) {
        <p-panel [header]="elementDescr[element.value]" styleClass="element">
            <ng-template #icons>
                <p-button icon="pi pi-plus"
                          size="small"
                          severity="secondary"
                          rounded
                          text
                          (click)="addElement(element.value)"/>
            </ng-template>

            @switch (element.value) {
                @case (elementTypes.CHART) {
                    <dashboard-preview-line-chart/>
                }
                @case (elementTypes.DIAGRAM) {
                    <dashboard-preview-bar-chart/>
                }
                @case (elementTypes.GAUGE) {
                    <dashboard-preview-gauge-chart/>
                }
                @case (elementTypes.DEVICE_STATE) {
                    <dashboard-preview-device-state/>
                }
                @case (elementTypes.SINGLE_VALUE) {
                    <dashboard-preview-single-value/>
                }
                @default {
                    {{ element.value }}
                }
            }
        </p-panel>
    }
</p-drawer>
